import { Component, computed, input } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'avatar',
  template: `
    <div class="avatar">
      @if (src() !== undefined) {
        <img [src]="src()" />
      } @else {
        {{ initials() }}
      }
    </div>
  `,
  styles: `
    .avatar {
      border-radius: 9999px;
      background-color: #007db8;
      overflow: hidden;

      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      text-align: center;
      width: 34px;
      height: 34px;
      font-size: 14px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  `,
})
export class Avatar {
  readonly name = input.required<string>();
  readonly src = input<SafeUrl | undefined>();
  readonly initials = computed(() => {
    return this.name()
      .trim()
      .split(/\s+/)
      .slice(0, 2)
      .map((part) => part.charAt(0))
      .join('')
      .toUpperCase();
  });
}
